module.exports = __webpack_public_path__ + "media/Images/icon-money-sync-o-affd3398507273789bb03dbdc79a7908.svg";